import React, { useState } from "react";
export default function UserAddress() {
    const [addresses, setAddresses] = useState([
        {
            type: "Home",
            name: "Nandha Kumar",
            address: "12 Gandhi Street, Erode, Tamil Nadu",
            phone: "9487924282"
        },
        {
            type: "Office",
            name: "Nandha Kumar",
            address: "IT Park Road, Coimbatore",
            phone: "9487924282"
        }
    ]);
    return (
        <div className="address-wrapper">
            <div className="address-top">
                <h2>My Address</h2>
                <button className="add-address-btn">+ Add Address</button>
            </div>
            <div className="address-grid">
                {addresses.map((a, index) => (
                    <div className="address-card" key={index}>
                        <h4>{a.type}</h4>
                        <p>{a.name}</p>
                        <p>{a.address}</p>
                        <p>{a.phone}</p>
                        <div className="address-actions">
                            <button className="edit-btn">Edit</button>
                            <button className="delete-btn">Delete</button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}